export default __webpack_public_path__ + "static/media/logo-KCNI.0aceb39a.png";